export const environment = {
    production: false,
    domain: 'wett',
    livetracker: false,
    resultModalSportradar: false,
    systemName: 'wettarena',
    bRSmallWidgetApiKey: 'wSmall-09326da315afa33',
    bRSwipeWidgetApiKey: 'wSwipe-09326da315afa33',
};

export const getBetGeniusLiveTracker = (BetradarMatchId, LangId) => {
    let url =
        'https://bsdemo.betstream.betgenius.com/betstream-view/page/betgenius/footballscorecentre?eventId=' +
        (-1 * BetradarMatchId).toString();
    // console.warn('URL',url);
    return url;
};

export const scoreBoxBannerUrl = 'https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/scorebox.png';
export const pitchLogo = 'https://wettarena.com/angular/dist/assets/images/logo.png';
export const scoreSplashUrl = 'https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/terminal.jpg';

export const socketURL = 'https://socket.wettarena.online';
export const sportradarStats = 'https://st-cdn001.akamaized.net/wettarena/';
export const disableBalance = false;
